<template>
  <div class="header">
    <el-header>
      <div class="title" @click="go">首页</div>
      <el-badge :is-dot=IsDot class="item">
        <el-button @click="Drawer" class="share-button" icon="el-icon-message-solid" circle type='success'></el-button>
      </el-badge>
      <div @click="logout" class="logout">退出登录</div>
    </el-header>

    <el-drawer
      class="drawer_"
      title="SKU信息变更记录"
      :visible.sync="drawer"
      :direction="direction">
      <div class="block" style="margin-left:1vw">
        <div class="radio" style="margin-left:1vw">
          排序：
          <el-radio-group v-model="reverse">
            <el-radio :label="true">倒序</el-radio>
            <el-radio :label="false">正序</el-radio>
          </el-radio-group>
        </div>
        <el-timeline :reverse="reverse" style="margin:2vw">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.time">
            {{activity.things}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getIsDot,editIsDot,GetSkuRecord } from '../../api/api';
export default {
  data() {
    return {
      IsDot:false,
      drawer: false,
      direction: 'rtl',
      reverse:false,
      activities: [],
    };
  },
  created () {
    var params = {
      name:window.localStorage.getItem('un')
    }
    getIsDot(params).then(res => {
      if(res.status == 200 && (res.data[0].status == 0)){
        this.IsDot = false;
      }else if(res.status == 200 && (res.data[0].status != 0)){
        this.IsDot = true;
      }
    });
  },
  methods: {
    logout() {
      // this.$auth.logout();
      this.$router.push({ path: "/" });
    },
    go(){
      this.$router.replace({ path: "/home/orderlist" });
    },
    Drawer(){
      GetSkuRecord().then(res => {
        console.log(res);
        this.activities = res.data;
      })
      this.IsDot = false;
      this.drawer = true;
      var params = {
        name:window.localStorage.getItem('un')
      } 
      editIsDot(params).then(res => {
        console.log(res);
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  .el-header {
    background: #409eff;
    color: #fff;
    // line-height: 60px;
    padding-top: 1.5vh;
    display: flex;
    justify-content: space-between;
    .title {
      width: 300px;
      font-size: 24px;
    }
    .logout {
      width: 100px;
    }
  }
}
</style>
